import { render, staticRenderFns } from "./FeaturedIcon.vue?vue&type=template&id=50788b72&scoped=true&"
import script from "./FeaturedIcon.vue?vue&type=script&lang=js&"
export * from "./FeaturedIcon.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedIcon.vue?vue&type=style&index=0&id=50788b72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50788b72",
  null
  
)

export default component.exports